function MediaFile(mediaFileJTree) {
  if (!(this instanceof MediaFile)) {
    return new MediaFile(mediaFileJTree);
  }

  //Required attributes
  this.src = xml.keyValue(mediaFileJTree);
  this.delivery = mediaFileJTree.attr('delivery');
  this.type = mediaFileJTree.attr('type');
  this.width = mediaFileJTree.attr('width');
  this.height = mediaFileJTree.attr('height');

  //Optional attributes
  this.codec = mediaFileJTree.attr('codec');
  this.id = mediaFileJTree.attr('id');
  this.bitrate = mediaFileJTree.attr('bitrate');
  this.minBitrate = mediaFileJTree.attr('minBitrate');
  this.maxBitrate = mediaFileJTree.attr('maxBitrate');
  this.scalable = mediaFileJTree.attr('scalable');
  this.maintainAspectRatio = mediaFileJTree.attr('maintainAspectRatio');
  this.apiFramework = mediaFileJTree.attr('apiFramework');
}